<script setup>
import AppFooter from '@/design/default/AppFooter.vue'
import AppHeader from '@/design/default/AppHeader.vue'
import Notifications from '@/components/Notifications.vue'
import router from '@/router/router'

</script>

<template>
  <Notifications />
  <div class="d-flex flex-column min-vh-100">
    <AppHeader />

    <div class="flex-grow-1" style="margin-top: 59px;">
      <router-view v-slot="{ Component }">
        <component :is="Component" :key="router.currentRoute.value.path" />
      </router-view>
    </div>

    <AppFooter />
  </div>
</template>